import { FC, PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';

interface ModalContainerProps {
  isOpen: boolean;
  transparent?: boolean;
}

const ModalContainer: FC<PropsWithChildren<ModalContainerProps>> = ({ isOpen, children, transparent }) => {
  if (!isOpen) return null;

  return createPortal(
    <div className={`modalContainer ${transparent ? 'transparent' : ''}`}>{children}</div>,
    document.getElementById('modal-root') as HTMLElement
  );
};

export default ModalContainer;
